(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pdp-logos"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const decorationSection = document.querySelector('.oyc-decoration');
    const imageInput = document.getElementById('selected-image');

    if (!decorationSection || !imageInput) return;

    const decorationMode =
      decorationSection.dataset.decorationMode || 'logo selection';

    if (decorationMode === 'decoration package') {

  const packageName =
  decorationSection.dataset.packageName ||
  'Decoration Package';

  imageInput.name = 'properties[Package]';
  imageInput.value = packageName;

  return;
}

    imageInput.name = 'properties[Selected Logo]';

    function updateSelectedOption() {
      const selectedRadio = decorationSection.querySelector(
        '.image-option-card input[type="radio"]:checked'
      );

      if (!selectedRadio) return;

      imageInput.value = selectedRadio.value;
    }

    decorationSection
      .querySelectorAll('.image-option-card input[type="radio"]')
      .forEach(function (radio) {
        radio.addEventListener('change', updateSelectedOption);
      });

    updateSelectedOption();
  });
  } catch(e) { console.error(e); }
})();

})();
